import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

//import the only one global CSS file
import './styles/style.css';

// import created components (full pages) :
import Calendar from './pages/calendar/Calendar.jsx'
import Admin from './pages/admin/Admin.jsx'
import Eleves from './pages/eleves/Eleves.jsx'
import Confirmation from './pages/confirmation/Confirmation.jsx'
import Error from './pages/error/Error.jsx'
import ResaSuccess from './pages/resasuccess/ResaSuccess.jsx'
import ModifSuccess from './pages/modifsuccess/ModifSuccess.jsx'
import EditResa from './pages/editresa/EditResa.jsx'
import Home from './pages/home/Home.jsx'
import StartResa from './pages/startresa/StartResa.jsx'
import ClientInfosPage from './pages/clientinfos/ClientInfosPage.jsx'
import MatchResa from './pages/matchresa/MatchResa.jsx'
import ResaMatched from './pages/resamatched/ResaMatched.jsx'
import Login from './pages/manager/login/Login.jsx'
import Paiement from './pages/paiement/Paiement.jsx'
import ManagerCalendar from './pages/manager/calendar/ManagerCalendar.jsx'
import ManagerClients from './pages/manager/clients/ManagerClients.jsx'
import ManagerReservations from './pages/manager/reservations/ManagerReservations.jsx'
import ManagerLocations from './pages/manager/locations/ManagerLocations.jsx'
//location
import HomeLocation from './pages/location/homeLocation/HomeLocation.jsx'
import LocationSteps from './pages/location/steps/LocationSteps.jsx'
import LocationMatcher from './pages/location/match/LocationMatcher.jsx'
import LocationMatchConfirm from './pages/location/match-confirm/LocationMatchConfirm.jsx'

//Redux hooks and tools
import { Provider } from 'react-redux'
import { store } from './store/store.jsx';
import LocationPayment from './pages/location/payment/LocationPayment';



function App() {
  return (
    <React.StrictMode>
      <Provider store={store}> {/* Redux global state provider */}
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/location" element={<HomeLocation />} />
            <Route path="/location/steps" element={<LocationSteps />} />
            <Route path="/location/match/:refLoc/:idLoc" element={<LocationMatcher />} />
            <Route path="/location/payment/:refLoc/:idLoc" element={<LocationPayment />} />
            <Route path="/location/payment-confirm/:refLoc/:idLoc" element={<LocationPayment />} />
            <Route path="/location/match-confirm/:refLoc/:idLoc" element={<LocationMatchConfirm />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/startresa" element={<StartResa />} />
            <Route path="/eleves" element={<Eleves />} />
            <Route path="/infosclient" element={<ClientInfosPage />} />
            <Route path="/confirmation" element={<Confirmation />} />
            <Route path="/resasuccess" element={<ResaSuccess />} />
            <Route path="/modifsuccess" element={<ModifSuccess />} />
            <Route path="/paiement/:idResa/:idClient" element={<Paiement />} />
            <Route path="/confirm-paiement/:idResa/:idClient" element={<Paiement />} />
            <Route path="/editresa/:idResa/:idClient" element={<EditResa />} />
            <Route path="/matchresa/:idResa/:idClient" element={<MatchResa />} />
            <Route path="/resamatched/:idResa" element={<ResaMatched />} />
            <Route path="/manager/login" element={<Login />} />
            <Route path="/manager/clients" element={<ManagerClients />} />
            <Route path="/manager/reservations" element={<ManagerReservations />} />
            <Route path="/manager/locations" element={<ManagerLocations />} />
            <Route path="/manager" element={<ManagerCalendar />} />
            <Route path="*" element={<Error />} />
          </Routes>
        </Router>
      </Provider>
    </React.StrictMode>
  );
}

export default App;
